import { TENANT, type TenantLanguagesConfig } from '../tenant'

import { LOCALE } from './LOCALE'

export const i18nLocaleByTenantAndLanguage: {
  [tenant in TENANT]: Record<
    TenantLanguagesConfig[tenant]['languages'][number],
    LOCALE
  >
} = {
  [TENANT.AT]: {
    de: LOCALE.DE_AT,
  },
  [TENANT.BE]: {
    fr: LOCALE.FR_BE,
    nl: LOCALE.NL_BE,
  },
  [TENANT.CH]: {
    de: LOCALE.DE_CH,
    fr: LOCALE.FR_CH,
  },
  [TENANT.COM]: {
    de: LOCALE.DE_DE,
  },
  [TENANT.FR]: {
    fr: LOCALE.FR_FR,
  },
  [TENANT.IT]: {
    it: LOCALE.IT_IT,
  },
}
